import { Injectable, inject } from '@angular/core';

import { ReportsResponse } from '@app-model/api';
import { IGetReportsRequest } from '@app-model/request';
import { BehaviorSubject } from 'rxjs';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private _apiService = inject(ApiService);

  reports: BehaviorSubject<ReportsResponse[]> = new BehaviorSubject<ReportsResponse[]>([]);

  getReports(request: IGetReportsRequest): void {
    this._apiService.getReports(request).subscribe((menu: ReportsResponse[]) => this.reports.next(menu));
  }
}
